export default {"src":"/_next/static/media/HPE.c031ee6e.svg","height":18,"width":18};